import { styled } from 'linaria/react';
import { css } from 'linaria';

export const StmTextContainer = styled.div`
  a {
    display: flex;
    flex-direction: column;
    max-width: 120px;
    text-decoration: none;
  }
`;

export const labelText = css`
  padding-bottom: 4px;
`;
